import React from 'react';
import ReactDOM from "react-dom";
import MetricsContainer from './components/MetricsContainer';
import DeliveriesDataTable from './components/DeliveriesDataTable';
import InstallationsDataTable from './components/InstallationsDataTable';

export default function Dashboard(props) {
  const {
    metrics,
    canViewData,
  } = props;

  return (
    <>
      {canViewData && (
        <>
          <MetricsContainer
            metrics={metrics}
          />
          <DeliveriesDataTable />
          <InstallationsDataTable />
        </>
      )}
    </>
  );
}

const container = document.getElementById('dashboard-content');

if (container) {
  ReactDOM.render(
  <Dashboard
    metrics={JSON.parse(container.dataset.metrics)}
    canViewData={container.dataset.canViewData}
  />, container);
}
